export const tooltipStyles = {
  tooltip: {
    backgroundColor: "#eaebed",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  },
  arrow: {
    color: "#eaebed",
  },
};
